import { TwAutocompleteOption } from '../components/TwAutocomplete/TwAutocomplete';
import { HAZMAT_TYPES, ROUTING_TYPES } from '../providers/User/User.model';
import { PROVIDER } from '../providers/User/User.model';

export const routingAppOptions: TwAutocompleteOption[] = [
  {
    id: 'pc-miler',
    value: PROVIDER.PC,
    label: 'PC Miler'
  },
  {
    id: 'google',
    value: PROVIDER.GOOGLE,
    label: 'Google Maps'
  }
];

export const routeTypeOptions: TwAutocompleteOption[] = [
  {
    id: 'practical',
    value: ROUTING_TYPES.PRACTICAL,
    label: 'Practical'
  },
  {
    id: 'shortest',
    value: ROUTING_TYPES.SHORTEST,
    label: 'Shortest'
  },
  {
    id: 'fastest',
    value: ROUTING_TYPES.FASTEST,
    label: 'Fastest'
  }
];

export const hazmatOptions: TwAutocompleteOption[] = [
  {
    id: 'general',
    value: HAZMAT_TYPES.GENERAL,
    label: 'General'
  },
  {
    id: 'caustic',
    value: HAZMAT_TYPES.CAUSTIC,
    label: 'Caustic'
  },
  {
    id: 'explosives',
    value: HAZMAT_TYPES.EXPLOSIVES,
    label: 'Explosives'
  },
  {
    id: 'flammable',
    value: HAZMAT_TYPES.FLAMMABLE,
    label: 'Flammable'
  },
  {
    id: 'inhalants',
    value: HAZMAT_TYPES.INHALANTS,
    label: 'Inhalants'
  },
  {
    id: 'radioactive',
    value: HAZMAT_TYPES.RADIOACTIVE,
    label: 'Radioactive'
  },
  {
    id: 'harmful-to-water',
    value: HAZMAT_TYPES.HARMFUL_TO_WATER,
    label: 'Harmful to water'
  },
  {
    id: 'tunnel',
    value: HAZMAT_TYPES.TUNNEL,
    label: 'Tunnel'
  }
];

export const locationLinkOptions: TwAutocompleteOption[] = [
  { id: 'link', label: 'Open location in Google Maps', value: true },
  { id: 'no-link', label: 'Do nothing - do not make locations linkable', value: false }
];
